import { render } from "./Testimonial.vue?vue&type=template&id=c79657b8&scoped=true&ts=true"
import script from "./Testimonial.vue?vue&type=script&lang=ts"
export * from "./Testimonial.vue?vue&type=script&lang=ts"

import "./Testimonial.vue?vue&type=style&index=0&id=c79657b8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79657b8"]])

export default __exports__